import {EntityType, UserRole, UserRoleForm} from "./Model";
import {arrayResource, EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import {UserRoles_Read} from "../util/access/Permission";


interface RoleStore extends EntityStore<UserRole[]> {
    createRole: (form: UserRoleForm) => Promise<UserRole>,
    updateRole: (role: UserRole, form: UserRoleForm) => Promise<UserRole>,
    deleteRole: (role: UserRole) => Promise<void>,
}

export const useRoleStore = create<RoleStore>()(
    arrayResource<UserRole, RoleStore>(EntityType.UserRoles, builder => {
        const rest = builder.crud<UserRoleForm>('/roles', 'id');

        return {
            remoteValue: builder.all(UserRoles_Read, () => rest.getAll()),
            createRole: builder.createAndPatch<UserRoleForm>(rest),
            updateRole: builder.updateAndPatch<UserRoleForm>(rest),
            deleteRole: builder.deleteAndPatch<UserRoleForm>(rest),
        };
    })
);

startEntityStore(useRoleStore);
